import React from 'react';
import { motion } from 'framer-motion';

export default function SectionSeparator({ title }) {
  return (
    <div className="w-full flex justify-center items-center py-0 mb-10 overflow-hidden">
      <div className="relative flex items-center justify-center w-full max-w-[100%] px-[10px] xl:px-[70px] gap-6 md:gap-10">
        {/* Left Line */}
        <motion.div 
          initial={{ opacity: 0, width: "0%" }}
          whileInView={{ opacity: 1, width: "100%" }}
          transition={{ duration: 1.2, ease: "easeOut" }}
          className="h-[1px] bg-gradient-to-r from-transparent via-[#D4AF37] to-[#D4AF37] w-full flex-1 opacity-50"
        />

        {/* Center Content: Title or Icon */}
        {title ? (
           <motion.h2
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2, ease: "easeOut" }}
            className="flex-shrink-0 font-heading text-[clamp(1.5rem,4vw,7rem)] text-[#14213D] font-normal text-center leading-tight max-w-[80%] md:max-w-none px-2"
          >
            {title}
          </motion.h2>
        ) : (
          <motion.div
            initial={{ opacity: 0, scale: 0, rotate: -45 }}
            whileInView={{ opacity: 1, scale: 1, rotate: 0 }}
            transition={{ duration: 0.8, delay: 0.3, ease: "backOut" }}
            className="text-[#D4AF37] flex-shrink-0"
          >
            <div className="w-3 h-3 border border-[#D4AF37] rotate-45 bg-[#D4AF37]/20" />
          </motion.div>
        )}

        {/* Right Line */}
        <motion.div 
          initial={{ opacity: 0, width: "0%" }}
          whileInView={{ opacity: 1, width: "100%" }}
          transition={{ duration: 1.2, ease: "easeOut" }}
          className="h-[1px] bg-gradient-to-l from-transparent via-[#D4AF37] to-[#D4AF37] w-full flex-1 opacity-50"
        />
      </div>
    </div>
  );
}
